/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for sqlOperatorType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sqlOperatorType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="groupBy"/&gt; &lt;enumeration value="minimum"/&gt; &lt;enumeration value="maximum"/&gt; &lt;enumeration value="average"/&gt; &lt;enumeration value="automatic"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SqlOperatorType extends Enum{

	enumValue = null;

	static  GROUP_BY = SqlOperatorType.newLiteral("groupBy");

	static  MINIMUM = SqlOperatorType.newLiteral("minimum");

	static  MAXIMUM = SqlOperatorType.newLiteral("maximum");

	static  AVERAGE = SqlOperatorType.newLiteral("average");

	static  AUTOMATIC = SqlOperatorType.newLiteral("automatic");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SqlOperatorType.values().length); ++i) {
			if (SqlOperatorType.values()[i].enumValue == v) {
				return SqlOperatorType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SqlOperatorType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SqlOperatorType.js